/**
 * Typ popisující zápstupce výsledku hledání aktivity ve workflow.
 */
export type ActivityPoistionSearchResult = {
    readonly setName: string;
    readonly setId: string;
    readonly activityName: string;
    readonly activityId: string;
};
